import { Button } from "@/atoms-react/button/Button.react";
import { Modal, ModalContent, type ModalProps } from "@/atoms-react/modal/index.react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { FormAddIban } from "../form-add-iban/index.react";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import { useKYCContext } from "@/features/auth/hooks/use-kyc-context";

type ModalAddIbanProps = {
  iban?: string;
  onValidated?: (iban: string, main: boolean) => void;
  onClose: () => void;
} & ModalProps;

export const ModalAddIban = ({
  iban = "",
  onValidated = () => {},
  onClose,
  ...props
}: ModalAddIbanProps) => {
  const { t } = useTranslation(["atoms"]);
  const { kycLevel } = useKYCContext();
  const isUserLevel2 = kycLevel ? kycLevel > 1 : true;

  const [newIban, setNewIban] = useState<string>(iban);
  const [ibanMain, setIbanMain] = useState<boolean>(false);
  const [ibanValid, setIbanValid] = useState(false);

  return (
    <Modal
      {...props}
      onClose={() => {
        onClose();
        setIbanMain(false);
        setIbanValid(false);
      }}
      maxWidthClassName="max-w-2xl"
    >
      <ModalContent
        title={
          iban ? t("molecules.modal_add_iban.title_modify") : t("molecules.modal_add_iban.title")
        }
      >
        <div className={"mt-4 flex flex-col items-end opacity-1"}>
          <div className={"mt-4 mb-6 w-full"}>
            <FormAddIban
              autoFocus
              onChange={(iban, valid) => {
                setNewIban(iban);
                setIbanValid(valid);
              }}
            />
          </div>

          <Checkbox
            value={ibanMain}
            required={false}
            onChange={(value) => setIbanMain(value)}
            disabled={isUserLevel2}
            dataCy="checkbox-main"
          >
            <Base className="mb-6 cursor-pointer">{t("molecules.modal_add_iban.main")}</Base>
          </Checkbox>

          <Button
            disabled={!ibanValid}
            shortcut="enter"
            className="w-max shrink-0"
            onClick={() => {
              const ibanIsMain = ibanMain;
              onValidated(newIban, ibanIsMain);
              setIbanMain(false);
              setIbanValid(false);
            }}
            icon={<ChevronRightIcon />}
            data-cy="button-save-iban"
          >
            {t("molecules.modal_add_address.confirm")}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};
